import React, { useEffect, useState, Fragment } from 'react'
import DataRow from "./DataRow";
import reportService from '../../../services/reportService';
import BeatLoader from "react-spinners/BeatLoader";
import { FaAngleDown } from "react-icons/fa";

const override = {
    display: "block",
    margin: "15px auto",
    borderColor: "red",
};

const summaryGridClass = "grid grid-cols-[0.8fr_1.2fr_1.2fr_1.2fr_0.8fr_0.8fr]";
const detailGridClass = "grid min-w-[1020px] grid-cols-[120px_120px_140px_100px_120px_150px_120px_100px_125px]";

const Summary = (props) => {
    const { data, fetchData,theme } = props;
    const { totalWinAmount, totalBetAmount, purchasedCount, overAmount, teamCount, selectedDate, activeCount } = data;
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [voucherList, setVoucherList] = useState([]);

    useEffect(() => {
        if (show) fetchDataDetails();
        //eslint-disable-next-line
    }, [show])

    const fetchDataDetails = async (v) => {
        try {
            setIsLoading(true);
            const payload = {
                teamCount: teamCount,
                selectedDate: selectedDate
            }

            const response = await reportService.reportByMixDetails(payload);

            if (response.status === 200) {
                setVoucherList(response.data.data);
            }
        }
        catch (error) {
            console.log(error)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <Fragment>
            <div className="grid w-full grid-cols-[44px_1fr] mt-2 rounded-2xl border border-customTitleColor bg-white text-customInk shadow-accountPanel dark:border-customBorder dark:bg-customSurface dark:text-customWhite customFontDangrek font-semibold text-xs min-h-14">
                <div className="flex items-center justify-center cursor-pointer">
                    <FaAngleDown
                        className={`transition-transform duration-300 ${show ? "rotate-180" : ""} text-customInk dark:text-customWhite text-base`}
                        onClick={() => setShow(prev => !prev)}
                    />
                </div>
                <div className={`${summaryGridClass} items-center gap-2 py-2 pr-4 text-center`}>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Mix Count</p>
                        <p>{teamCount}</p>
                    </div>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Total Bet Amount</p>
                        <p>{totalBetAmount.toLocaleString('en-us')}</p>
                    </div>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Total Risk</p>
                        <p>{totalWinAmount.toLocaleString('en-us')}</p>
                    </div>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Total Overed</p>
                        <p>{overAmount.toLocaleString('en-us')}</p>
                    </div>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Active</p>
                        <p>{activeCount}</p>
                    </div>
                    <div className="flex min-w-0 flex-col items-center gap-1">
                        <p className='font-bold'>Purchased</p>
                        <p>{purchasedCount}</p>
                    </div>
                </div>
            </div>
            {show &&
                <div className="mt-1 mx-3 overflow-x-auto">
                    <div className='w-full min-w-[1020px] text-xs font-bold rounded-t-2xl border border-customTitleColor bg-customGray text-customSecondaryText dark:border-customBorder dark:bg-customSurfaceMuted dark:text-customMuted mt-1'>
                        <div className={`${detailGridClass} items-center gap-3 px-4 py-3`}>
                            <div className='text-left'>
                                <p>Closest Time</p>
                            </div>
                            <div className='text-left'>
                                <p>Senior</p>
                            </div>
                            <div className='text-left'>
                                <p>VoucherID</p>
                            </div>
                            <div className='text-right'>
                                <p>Bet Amount</p>
                            </div>
                            <div className='text-right'>
                                <p>Risk</p>
                            </div>
                            <div className='text-right'>
                                <p>Overed Amount</p>
                            </div>
                             <div className='text-right'>
                                <p>Net Margin</p>
                            </div>
                            <div className='text-center'>
                                <p>Status</p>
                            </div>
                            <div className='text-center'>
                                Action
                            </div>
                        </div>
                    </div>
                    {
                        isLoading ?
                        <div className='w-full flex justify-center items-center py-10 bg-customGray dark:bg-customSurfaceMuted rounded-b-2xl'>
                            <BeatLoader
                                loading={isLoading}
                                color={theme === "light" ? '#292E4C' : "#FFFFFF"}
                                cssOverride={override}
                                size={18}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            </div>
                            :
                                voucherList.length === 0 ? <div className='flex items-center justify-center text-red'>No vouchers found</div> : 
                                voucherList.map((v, i) => {
                                    return (
                                        <DataRow
                                            data={v.mixDetailLists}
                                            key={i}
                                            hasDuplicataion={v.hasDuplicataion}
                                            teamCount={teamCount}
                                            fetchData={fetchData}
                                        />
                                    )
                                }
                                )
                    }
                </div>
            }
        </Fragment >
    )
}

export default Summary;


